type PaletteColor =
  | 'dark222'
  | 'darkGrey'
  | 'darkGrey80'
  | 'brownishGrey'
  | 'lightBlueGrey'
  | 'coral'
  | 'veryLightCoral'
  | 'clearBlue'
  | 'blue'
  | 'darkBlue'
  | 'lightClearBlue'
  | 'bluishPurple'
  | 'poisonGreen'
  | 'fadedOrange'
  | 'veryLightFadedOrange'
  | 'violet'
  | 'white'
  | 'darkGray'
  | 'gray87'
  | 'lynxWhite'
  | 'black'
  | 'blackAlpha'
  | 'lightBlack'
  | 'veryLightBlack'
  | 'lightSuccess'
  | 'darkSuccess'
  | 'darkGreen'
  | 'purple'
  | 'pinkSwan'
  | 'grey'
  | 'lightGray'
  | 'inputBorderColor'
  | 'inputBorderColorActive'
  | 'inputPlaceholderColor'
  | 'tomato'
  | 'whiteSmoke'
  | 'matterHorn'
  | 'mountainMist'
  | 'gray34'
  | 'nero'
  | 'eclipse'
  | 'black11'
  | 'lightGreyButtonBackground'
  | 'veryLightGreenOpacity'
  | 'darkPurple'
  | 'veryLightDarkPurple'
  | 'tomato'
  | 'gray'
  | 'green'
  | 'validGreen'
  | 'validGreen'
  | 'lightYellow'
  | 'lightsSilver'
  | 'athensGray'
  | 'lightEclipse'
  | 'hesInfoBoxBackground'
  | 'graniteGray'
  | 'greenSuccess'
  | 'LightCoral'
  | 'lightGreenBorder'
  | 'iron'
  | 'red'
  | 'yellow'
  | 'persianRed'
  | 'coral_01'
  | 'cornsilk'
  | 'wheat'
  | 'peru'
  | 'primaryGrey'
  | 'primaryBrand'
  | 'primaryBrandSoft'
  | 'primaryBrandDark'
  | 'bannerBgColor'
  | 'error'
  | 'inputColor'
  | 'inputBackgroundColor'
  | 'darkGreenScore'
  | 'green200'
  | 'lightGreenScore'
  | 'burntSienna'
  | 'errorColor'
  | 'orange';

export type Palette = {
  [key in PaletteColor]: string;
};

const palette: Palette = {
  bannerBgColor: '#353535',
  dark222: '#222',
  darkGrey: '#292a2c',
  darkGrey80: 'rgb(41,42,44, 0.8)',
  brownishGrey: '#636363',
  lightBlueGrey: '#cfd4de',
  coral: '#fa5851',
  LightCoral: 'rgba(250, 88, 81, 0.6)',
  veryLightCoral: 'rgba(250, 88, 81, 0.1)',
  clearBlue: '#1b75e2',
  blue: '#2c83ed;',
  darkBlue: '#084594',
  lightClearBlue: '#e8f1fc',
  bluishPurple: '#8036e5',
  poisonGreen: '#3cf11a',
  fadedOrange: '#fe9739',
  veryLightFadedOrange: 'rgba(254, 151, 57, 0.1)',
  violet: '#901be2',
  white: '#ffffff',
  whiteSmoke: '#f5f5f5',
  tomato: '#e2231b',
  error: '#d32f2f',
  darkGray: '#525252',
  gray87: '#dedede',
  lynxWhite: '#f7f7f7',
  lightSuccess: '#e0f7dc',
  darkSuccess: '#2fbd14',
  darkGreen: '#04a985',
  lightGreenScore: '#4BA687',
  purple: '#682a7a',
  pinkSwan: '#b6b5b5',
  black: 'rgb(0,0,0)',
  blackAlpha: 'rgba(0,0,0,0.85)',
  lightBlack: '#434343',
  veryLightBlack: 'rgba(58,58,58, 0.1)',
  grey: '#757575',
  lightGray: '#f3f3f3',
  inputBorderColor: '#d1cece',
  inputBorderColorActive: '#7d7d7d',
  inputPlaceholderColor: '#bfbfbf',
  matterHorn: '#4b4b4b',
  mountainMist: '#94979c',
  gray34: '#575757',
  nero: '#282828',
  eclipse: '#3a3a3a',
  lightEclipse: 'rgba(58, 58, 58, 0.2)',
  black11: '#0A0A0A',
  darkPurple: '#7b1fa1',
  veryLightDarkPurple: 'rgba(123, 31, 161, 0.1)',
  veryLightGreenOpacity: 'rgba(4, 169, 133, 0.1)',
  lightGreyButtonBackground: 'rgba(207, 212, 222, .2)',
  validGreen: '#00c269',
  gray: '#eeeeee',
  green: '#5cc85c',
  green200: '#E8F5F2',
  lightYellow: '#faf8f0',
  athensGray: '#f9fafb',
  lightsSilver: '#d8d8d8',
  hesInfoBoxBackground: '#fef4eb',
  greenSuccess: '#5acc45',
  graniteGray: '#5f6061',
  coral_01: '#fdeeec',
  lightGreenBorder: ' #eef2f6',
  iron: '#CFD4DE',
  red: '#E2231B',
  yellow: '#FFB800',
  persianRed: '#D1392B',
  cornsilk: '#fcf8e3',
  wheat: '#faebcc',
  peru: '#8a6d3b',
  primaryGrey: '#221e1f',
  darkGreenScore: '#4CA671',
  burntSienna: '#E96358',
  primaryBrand: 'rgb(232, 182, 90)',
  primaryBrandSoft: 'rgb(232, 182, 90, 0.5)',
  primaryBrandDark: 'rgb(203, 136, 1)',
  inputColor: '#636363',
  inputBackgroundColor: '#f7f7f7',
  errorColor: '#e2231b',
  orange: '#FE9739',
};

export default palette;
